import React, { ReactElement } from 'react';

import {
  Footer,
  FooterNavigationRecord,
  FooterSocialLink,
} from '../../components/Footer';
import { PATHS } from '../../constants/paths';
import { GET_QUOTES_CLICKED } from '../../constants/analytics';
import { trackEvent } from '../../modules/analytics';
import { useRouter } from 'next/router';
import { Icons } from '@feast-it/ui/light';
import { getAbsoluteUrl } from '@/helpers/formatUrl';

const paymentTypes: (keyof Icons)[] = ['Visa', 'Mastercard', 'Amex', 'Stripe'];

const socialLinks: FooterSocialLink[] = [
  {
    type: 'Facebook',
    href: 'https://www.facebook.com/Feastitofficial',
  },
  {
    type: 'Instagram',
    href: 'https://www.instagram.com/feast._.it',
  },
  {
    type: 'Twitter',
    href: 'https://twitter.com/Feast_it',
  },
];

export function FooterContainer(): ReactElement {
  const router = useRouter();

  const navigation: FooterNavigationRecord = {
    services: {
      heading: 'Services',
      items: [
        {
          text: 'Catering',
          href: PATHS.listing(['catering']),
        },
        {
          text: 'Photographers',
          href: PATHS.listing(['photographers']),
        },
        {
          text: 'Mobile Bars',
          href: PATHS.listing(['mobile-bars']),
        },
        {
          text: 'Venues',
          href: PATHS.listing(['venues']),
        },
        {
          text: 'Other services',
          href: PATHS.sitemap,
        },
      ],
    },
    about: {
      heading: 'About',
      items: [
        {
          text: 'About us',
          href: PATHS.infoPages.about,
        },
        {
          text: 'How we work',
          href: PATHS.infoPages.howWeWork,
        },
        {
          text: 'Get quotes',
          href: PATHS.enquiryForm,
          onClick: () =>
            trackEvent(GET_QUOTES_CLICKED, {
              source: 'footer',
              currentPage: getAbsoluteUrl(router.asPath),
              destinationUrl: getAbsoluteUrl(PATHS.enquiryForm),
            }),
        },
        {
          text: 'Magazine',
          href: PATHS.blog(''),
        },
      ],
    },
    info: {
      heading: 'Info',
      items: [
        {
          text: 'Careers',
          href: PATHS.infoPages.careers,
        },
        {
          text: 'Contact us',
          href: PATHS.contact(''),
        },
        {
          text: 'T&Cs',
          href: PATHS.terms,
        },
        {
          text: 'Privacy Policy',
          href: PATHS.privacy,
        },
        {
          text: 'FAQs',
          href: PATHS.faqs,
        },
      ],
    },
  };

  return (
    <Footer
      navigation={navigation}
      paymentTypes={paymentTypes}
      socialLinks={socialLinks}
    />
  );
}
